import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    main: {
      minWidth: 700
    },
    inputBottom: {
      height: 30,
      width: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1
    },
    topContainer: {
      display: 'flex',
      paddingBottom: 15,
      justifyContent: 'space-between'
    },
    table1: {
      // padding: 8,
    },
    topBoxText: {
      fontSize: 14,
      color: '#000000'
    },
    btnContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    table: {
      padding: 15,
      backgroundColor: '#0099CC !important',
      color: '#FFFFFF',
      fontWeight: 'bold',
      fontSize: 16
    },
    searchItemContainer: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    listContainer: {
      padding: 15,
      backgroundColor: '#FFFFFF',
      borderRadius: 5
    },
    selectBoxContainer: {
      display: 'flex',
      marginRight: 10,
      paddingLeft: 5,
      paddingBottom: 2
    },
    selectBox: {
      border: 'solid 1px rgba(0,0,0,0.23)',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 4,
      overflow: 'hidden',
      maxWidth: 250,
      marginTop: 5,
      padding: '4px 10px 0',
      position: 'relative',
      '@media screen and (min-width:600px)': {
        top: -4
      },
      '@media screen and (max-width:600px)': {
        top: -2
      },
      height: 38,
      minWidth: 'fit-content',
      '&:hover': {
        borderColor: '#000000'
      }
    },
    selectBoxInRow: {
      backgroundColor: '#FFFFFF',
      fontSize: '0.9em',
      paddingLeft: '5px',
      paddingRight: '5px',
      minWidth: '90px'
    },
    tableContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start'
    },
    pagenationContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 30
    },
    centerMessage: {
      '@media screen and (min-width:600px)': {
        textAlign: 'center',
        padding: 15
      }
    },
    headerCellMedium: {
      minWidth: 113
    },
    headerCellButtons: {
      minWidth: 360
    },
    textAlignCenter: {
      textAlign: 'center'
    },
    textAlignRight: {
      textAlign: 'right'
    },
    gridContainerPadding: {
      padding: '15px 0 15px 0'
    },
    listTableButtonContainer: {
      display: 'flex',
      height: 36.5,
      justifyContent: 'center'
    },
    searchItem: {
      paddingBottom: 10
    },
    searchItemLabel: {
      marginRight: 10,
      display: 'flex',
      alignItems: 'center',
      minWidth: 'fit-content'
    },
    checkboxLabel: {
      cursor: 'pointer',
      position: 'relative',
      top: -6
    },
    checkboxContainer: {
      paddingRight: 20
    },
    checkboxContainerRwd: {
      position: 'relative',
      left: -9
    },
    borderBottomGray: {
      borderBottom: 'solid 1px rgba(0,0,0,0.23)'
    },
    constructInput: {
      width: '300px'
    },
    divisionInput: {
      width: '120px'
    },
    workerNameInput: {
      width: '200px'
    },
    workerNameInputRwd: {
      width: '95%',
      position: 'relative',
      top: 2
    },
    searchButtonContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'right'
    },
    searchButtonWrapperBasic: {
      marginLeft: '10px',
      position: 'relative',
      top: -14
    },
    toSiteProcessButtonWrapperBasic: {
      marginLeft: '10px',
      borderLeft: '1px solid #cfcfcf',
      paddingLeft: '20px',
      position: 'relative',
      top: -14
    },
    searchButtonWrapperRwd: {
      display: 'flex',
      justifyContent: 'end',
      position: 'relative',
      top: -3,
      left: 10
    },
    displayLimitLabelRwd: {
      marginRight: 10,
      paddingTop: 5
    },
    displayLimitWrapperRwd: {
      display: 'flex'
    },
    dateInputContainerRwd: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      top: 1
    },
    dateFromToSpan: {
      margin: '0px 5px'
    },
    helperText: {
      color: '#F44336',
      fontSize: '0.75rem',
      position: 'relative',
      top: '-6px',
      marginLeft: '8px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;'
    },
    disabledButton: {
      visibility: 'hidden'
    },
    currentDetailRow: {
      backgroundColor: '#AAF9F5 !important'
    },
    loadingContainer: {
      height: 650,
      backgroundColor: '#F5F5F5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    },
    detailCellWordBreak: {
      wordBreak: 'break-all'
    },
    editButtonBoxMobile: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end'
    },
    editButtonMobile: {
      alignSelf: 'center',
      width: window.innerWidth * 0.6,
      margin: 5
    }
  })
);
